import moment from 'moment';
var _service;
function _getService() {
    if(!_service) {
      _service = this;
      return _service
  }
  return _service
}

function _setToken(response) {
    localStorage.setItem('token', response?.access);
    localStorage.setItem('connection_time', moment().format('hh:mm A'));
    localStorage.setItem('disconnection_time', moment().add(15, 'minutes').format('hh:mm A'));
}

function _getAccessToken() {
    return localStorage.getItem('token');
}

function _getRefreshToken() {
    return localStorage.getItem('refresh_token');
}

function _clearToken() {
    localStorage.removeItem('token');
    localStorage.removeItem('refresh_token');
}

export const LocalStorageService = {
    _getService,
    _setToken,
    _getAccessToken,
    _getRefreshToken,
    _clearToken
};